import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, GridItem, Link } from '@coolblue-development/freddy';
import selectMainProductTrigger from '@coolblue-development/ga4-events/triggers/StoreStockOverlay/selectMainProductTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { ProductTitle, SquareProductImage } from '@coolblue-development/next-patterns/client';
import { SalesPrice, SalesPriceCurrent } from '@coolblue-development/next-sales-price/client';
export const StoresStockOverlayHeader = ({ product, personalPrice }) => {
    var _a;
    const { trackEvent } = useAnalytics();
    const handleProductClick = () => {
        trackEvent(selectMainProductTrigger({
            index: 1,
            total_indices: 1,
            item_id: product.id,
            sub_feature: 'generic_store_stock_overlay',
        }));
    };
    return (_jsxs(Grid, { gap: 200, mb: 400, templateColumns: "auto 1fr", children: [_jsx(GridItem, { children: _jsx(SquareProductImage, { size: "small", imageId: String((_a = product.primaryImage) === null || _a === void 0 ? void 0 : _a.id), alt: product.name, loading: "eager" }) }), _jsxs(GridItem, { children: [_jsx(ProductTitle, { children: _jsx(ProductTitle.Title, { children: _jsx(Link, { href: "#", onClick: handleProductClick, children: product.name }) }) }), _jsx(SalesPrice, { currentPrice: _jsx(SalesPriceCurrent, { price: product.salesPrice.includingVat }), personalPrice: personalPrice })] })] }));
};
//# sourceMappingURL=StoresStockOverlayHeader.js.map